import type { AnalyticsContext, AnalyticsParams, AnalyticsProvider } from '../types'

type GtagFn = (...args: unknown[]) => void

function stripUndefined (
  params: Record<string, string | number | boolean | undefined>
): Record<string, string | number | boolean> {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined)
  ) as Record<string, string | number | boolean>
}

export class GtagAnalyticsProvider implements AnalyticsProvider {
  readonly name = 'gtag'

  private readonly gtag: GtagFn
  private readonly measurementId: string

  constructor (gtag: GtagFn, measurementId: string) {
    this.gtag = gtag
    this.measurementId = measurementId
  }

  track (event: string, params?: AnalyticsParams): void {
    const clean = params ? stripUndefined(params) : undefined
    this.gtag('event', event, clean ?? {})
  }

  identify (userId: string): void {
    this.gtag('config', this.measurementId, { user_id: userId })
  }

  setContext (context: Partial<AnalyticsContext>): void {
    const mapped = stripUndefined({
      user_id: context.userId,
      company_id: context.companyId,
      erp_version: context.erpVersion,
      environment: context.environment
    })
    if (Object.keys(mapped).length === 0) {
      return
    }
    this.gtag('set', mapped)
  }

  clearIdentity (): void {
    this.gtag('set', { user_id: null, company_id: null })
  }
}
